import React, { useEffect, useContext, useState } from "react";
import Error from "../../../components/Error";
import AuthContext from "../../../context/AuthContext";
import GenerateScript from "../../../components/GenerateScript";
import Loader from "../../../components/Loader";
import AlertDialog from "../../Settings/components/AlertDialog";
import EventsLists from "./Components/EventsLists";
import { WarnToaster } from "../../../utils/toaster";
import { useNavigate } from "react-router-dom";


export default function Default() {
  const {
    eventList,
    focus,
    setEnableSaveBtn,
    setFieldData,
    enableSaveBtn,
    pageInfo,
    getUserInfo,
    handleSaveAll,
  } = useContext(AuthContext);
  const [enableExtensionModal, setEnableExtensionModal] = useState(true);
  const [enableUserModal, setEnableUserModal] = useState(true);
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const [enableLoader, setEnableLoader] = useState(true);
  const titleLists = [];

  useEffect(() => {
    const fetchData =async () => {
      try {
        const getUserRes = await getUserInfo();
        if (!getUserRes) {
          setEnableUserModal(false);
        } else {
          setEnableUserModal(true);
          setUserData(getUserRes);
        }
        if (!getUserRes.defaultURL && !getUserRes.defaultEnv) {
          // WarnToaster("please choose the default url and env");
          navigate('/dashboard/settings');
        }
        const pageData = await pageInfo(getUserRes);
        setEnableExtensionModal(pageData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setEnableLoader(false); 
      }
    };
    fetchData();
  }, []);
  return (
    <>
      {/* dashboard widgets */}
      {!enableUserModal && <AlertDialog userInfo={userData}/>}
      <GenerateScript />
      {enableSaveBtn && (
        <button
          type="button"
          className="m-2 float-right rounded-md bg-[#58439F] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => handleSaveAll()}
        >
          Save All
        </button>
      )}
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        {enableLoader && <Loader/>}
        {(eventList.length === 0 || !userData) && !enableLoader && <Error/>}
        {userData && (<EventsLists userInfo={userData} eventList={eventList} setEnableSaveBtn={setEnableSaveBtn} titleLists={titleLists} setFieldData={setFieldData} enableExtensionModal={enableExtensionModal} />)}
      </div>
    </>
  );
}
